export enum EtatAdministratif {
  ACTIF = 'ACTIF',
  FERME = 'FERME',
}